"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const capitalize_1 = __importDefault(require("lodash/capitalize"));
class Page {
    constructor(idx, title, rawpath) {
        this.idx = idx;
        this.title = title;
        this.rawpath = rawpath;
        this.path = this.rawpath
            .split('*')
            .join('')
            .split(':id')
            .join('')
            .split(':viewId')
            .join('')
            .split(':staffid')
            .join('');
    }
    matches(p) {
        return p.indexOf(this.path) >= 0;
    }
    get priority() {
        if (this.path.indexOf('*') >= 0)
            return -1;
        return this.idx;
    }
}
const findPageForPath = (path) => {
    const found = ga.pages.filter(p => p.matches(path));
    found.sort((a, b) => a.priority - b.priority);
    if (found.length)
        return found[found.length - 1];
    return null;
};
const createPages = (paths) => {
    return Object.keys(paths).map((k, idx) => new Page(idx, k
        .split('_')
        .map(v => (0, capitalize_1.default)(v))
        .join(' > '), paths[k]));
};
const gtag = (...args) => {
    try {
        if (ga.broken)
            return;
        if (!window['gtag']) {
            return setTimeout(() => {
                // eslint-disable-next-line prefer-spread
                gtag.apply(null, args);
            }, 200);
        }
        window['gtag'].apply(null, args);
    }
    catch (_a) { }
};
const ga = {
    pages: [],
    broken: false,
    appName: '',
    init: (appName, pages) => {
        ga.appName = appName;
        ga.pages = createPages(pages);
        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + lib_env_1.default.googleAnalytics.key;
        script.async = true;
        document.body.appendChild(script);
        gtag('js', new Date());
        return setTimeout(() => {
            if (!window['gtag']) {
                ga.broken = true;
            }
        }, 2000);
    },
    pageview: (path, self) => {
        const page = findPageForPath(path);
        gtag('config', lib_env_1.default.googleAnalytics.key, {
            page_title: page ? 'WebApp > ' + page.title : 'WebApp',
            page_path: '/' + ga.appName + path,
            'user-id': self ? self.id : '',
            custom_map: {
                dimension1: 'organisation',
            },
            organisation: self ? self.organisationTitle : '',
        });
    },
};
exports.default = ga;
